// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A4S0","tabsBox":"styles_tabsBox__2a2gx","createButton":"styles_createButton__386pD"};